import { useQuery } from '@hooks/reactQuery';

import { getAssetRentCardItems } from '@api/assetsRent';

import { normalizeObject } from '@utils/common';
import { endOfDayInUTC, startOfDayInUTC } from '@utils/kpi-utils/date';

import { IGetAssetRentCardItemsDTO } from '@interfaces/rent/dto/assetRentDTO';

import { oneHundredYearsInMilliseconds } from '@constants/common';
import { ASSET_RENT_REQUEST_CARD_ITEMS } from '@constants/queryKeys';

const oneHundredYearsFromNow = Date.now() + oneHundredYearsInMilliseconds;

export const useQueryAssetRentCardItems = ({
	id,
	params: {
		page = 1,
		pageSize = 10,
		endRentDate,
		periodAvailability,
		searchValue = '',
		sortDirection = true,
		sortFieldName,
		startRentDate,
		typeId,
		approveStatus,
	},
	role,
}: IGetAssetRentCardItemsDTO) => {
	const {
		data,
		isLoading,
		isFetching,
		refetch: reFetchItems,
	} = useQuery({
		enabled: [id],
		refetchOnWindowFocus: false,
		queryKey: [
			ASSET_RENT_REQUEST_CARD_ITEMS,
			id,
			page,
			pageSize,
			endRentDate,
			periodAvailability,
			searchValue,
			sortDirection,
			sortFieldName,
			startRentDate,
			typeId,
			role,
			approveStatus,
		],
		queryFn: async () => {
			if (!id) return;

			return await getAssetRentCardItems({
				id,
				params: normalizeObject({
					page,
					pageSize,
					endRentDate: endRentDate ? endOfDayInUTC(new Date(endRentDate)) : startRentDate
						? oneHundredYearsFromNow
						: null,
					periodAvailability,
					searchValue,
					sortDirection,
					sortFieldName,
					startRentDate: startRentDate ? startOfDayInUTC(new Date(startRentDate)) : endRentDate ? 0 : null,
					typeId,
					approveStatus,
				}),
				role,
			});
		},
	});

	return {
		assetItems: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoading: isLoading || isFetching,
		reFetchItems,
	};
};
